import React from 'react'

export default function ViewStats({ studentViews, visitorViews, translations = {}, className = '' }) {
  if (!studentViews && !visitorViews) return null

  return (
    <div className={`flex items-center gap-2 text-xs text-gray-400 ${className}`}>
      <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
      </svg>
      <span>
        {(translations.student_views || '%{count} students viewed').replace('%{count}', studentViews || 0)}
        {' · '}
        {(translations.visitor_views || '%{count} visitor views').replace('%{count}', visitorViews || 0)}
      </span>
    </div>
  )
}
